import { mediaItems } from '@/mocks/home';

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-50">
      <div className="section-container">
        <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 mb-3">精彩片段</h2>
        <p className="text-sm text-foreground-500 mb-10">精选热门内容精彩瞬间，快速了解最值得看的亮点</p>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
          {mediaItems.map((item) => (
            <a
              key={item.id}
              href="#hero"
              className="group flex flex-col rounded-lg overflow-hidden bg-background-100 border border-background-200/70 hover:border-primary-200 transition-all duration-200 cursor-pointer no-underline"
            >
              <div className="relative w-full aspect-video overflow-hidden bg-background-200">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-black/10 group-hover:bg-black/20 transition-colors flex items-center justify-center">
                  <span className="w-14 h-14 flex items-center justify-center rounded-full bg-background-50/90 text-primary-500 group-hover:scale-110 transition-transform duration-300">
                    <i className="ri-play-fill text-2xl ml-0.5"></i>
                  </span>
                </div>
                <span className="absolute bottom-3 right-3 px-2 py-1 rounded bg-black/70 text-background-50 text-xs font-medium backdrop-blur-sm whitespace-nowrap">
                  {item.duration}
                </span>
              </div>
              <div className="p-4 flex flex-col gap-1">
                <h3 className="text-sm font-bold font-heading text-foreground-900 group-hover:text-primary-500 transition-colors">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-500">{item.desc}</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}